
import CartSidebarPrice from './CartSidebarPrice.vue';
import FulfillmentInfo from './FulfillmentInfo.vue';
import { AddToCartProduct } from 'JS/services/ProductService';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductGroupSelectorValue } from 'JS/types/Product';
import { PropType } from 'vue';
import { useBreakpoints } from "JS/composables/breakpoint";

export default {
	name: 'AddedToCartProduct',
	components: {
		CartSidebarPrice,
		FulfillmentInfo
	},
	props: {
		product: Object as PropType<AddToCartProduct>,
		selectedAttributes: Object as PropType<Record<string, IProductGroupSelectorValue>>,
		fulfillmentType: String,
		shippingDeliveryDate: String,
		shipZip: String,
		localStore: Object as PropType<ILocalStoreJson>,
	},
	computed: {
		storeCityState(): string {
			return `${this.localStore.city}, ${this.localStore.state}`;
		},
		isShip(): boolean {
			return this.fulfillmentType == FulfillmentType.StandardShipping;
		},
		isPickup(): boolean {
			return this.fulfillmentType == FulfillmentType.InStorePickup;
		},
		isDelivery(): boolean {
			return this.fulfillmentType == FulfillmentType.LocalDelivery;
		},
		deliveryWindowString(): string {
			return this.localStore.localDeliveryInformation?.label ?? "Local Delivery";
		},
		eachPrice(): string {
			if (this.product.addToCartPriceModel && this.product.addToCartPriceModel.price) {
				const comment = this.product.addToCartPriceModel.price.priceCommentText ?? 'ea';
				if (this.product.addToCartPriceModel.qty > 1) {
					return `($${this.product.addToCartPriceModel.eachPrice} ${comment})`;
				} else if (this.product.addToCartPriceModel.price.originalPrice != null) { // has original price
					return `$${this.product.addToCartPriceModel.price.originalPrice}`;
				} else if (this.product.addToCartPriceModel.price.regularPrice != null
					&& this.product.addToCartPriceModel.price.regularPrice != this.product.addToCartPriceModel.price.currentPrice
					&& this.product.addToCartPriceModel.price.currentPrice < this.product.addToCartPriceModel.price.regularPrice) { // has regular price
					return `$${this.product.addToCartPriceModel.price.regularPrice}`;
				}
			}
			return '';
		}
	},
	setup() {
		const { isMobile } = useBreakpoints();
		return {
			isMobile
		};
	}
};
